import React from 'react';
import { isEmpty, noop } from 'lodash';
import PropTypes from 'prop-types';
import { PropTypeBn } from '@blockcatio/tabby-library/lib/utilities/PropTypeBn';

import WalletInfo from '../../components/WalletInfo';
import RewardsList from '../../components/RewardsList';
import CampaignDetailsTable from '../../components/CampaignDetailsTable';
import PropTypeCampaign from '../../utilities/propTypes/PropTypeCampaign';
import { PropTypeStatusIsRequired } from '../../utilities/propTypes/PropTypeStatus';
import ManageCampaignLoadingImage from './manageCampaign-loading.png';
import { CampaignStatuses } from '../../constants';

const ManageCampaign = ({
  campaign,
  onCancelCampaign,
  isLoading,
  address,
  balance,
  catBalance,
  onWalletChange,
}) => {
  if (!isLoading && isEmpty(campaign)) return <div>Could not find campaign</div>;

  const cancelViewOptions = {
    title: 'Cancel Campaign',
    message: 'This will cancel the entire Campaign.',
  };
  const campaignCanceller = () => onCancelCampaign(campaign, '2000000000', cancelViewOptions);

  return (
    <div className="manage-campaign">
      <h1>Manage Campaign</h1>
      {!isLoading && (
        <WalletInfo
          address={address}
          balance={balance}
          catBalance={catBalance}
          onWalletChange={onWalletChange}
          showChangeWallet
        />
      )}
      {isLoading && <img src={ManageCampaignLoadingImage} alt="Manage Campaign Loading" />}
      <div className="content">
        <div className="campaign">
          {!isLoading && (
            <React.Fragment>
              <CampaignDetailsTable {...campaign} />
              {campaign.status.is(CampaignStatuses.confirmingSend) && (
                <p className="pending">
                  Your campaign transaction is currently pending. The time it takes for your
                  transaction to finalize will depend on network congestion. Please be patient while
                  your transaction is processed.
                </p>
              )}
              {campaign.status.is(CampaignStatuses.failed) && (
                <p className="error">
                  Unfortunately, your campaign was not created, as the transaction failed. You will
                  have to re-create your campaign and download new codes.
                </p>
              )}
              <button type="button" className="btn cancel" onClick={campaignCanceller}>
                Cancel Campaign
              </button>
            </React.Fragment>
          )}
        </div>
        {!isLoading && <RewardsList header="Redeemed Codes" rewards={campaign.rewards} />}
      </div>
    </div>
  );
};

ManageCampaign.defaultProps = {
  campaign: null,
  onCancelCampaign: noop,
  isLoading: false,
  address: '',
  balance: null,
  catBalance: null,
  onWalletChange: noop,
};

ManageCampaign.propTypes = {
  campaign: PropTypes.shape({
    ...PropTypeCampaign,
    ...PropTypeStatusIsRequired,
    rewards: PropTypes.arrayOf(PropTypes.shape({
      number: PropTypes.number,
      url: PropTypes.string,
    })).isRequired,
  }),
  onCancelCampaign: PropTypes.func,
  isLoading: PropTypes.bool,
  address: PropTypes.string,
  balance: PropTypeBn,
  catBalance: PropTypeBn,
  onWalletChange: PropTypes.func,
};

export default ManageCampaign;



// WEBPACK FOOTER //
// ./src/containers/campaigns/ManageCampaign.js